/*
 * Copyright (c) Nexign, JSC, 2020.
 */
/**
 * The component for display selected account on widget search accounts
 *
 * @author Anton Panasenko
 * @version 1.3.0
 * @since 1.3.0
 */

import { useSelector } from 'react-redux';

import { FeatureNameEnum } from '@/main/modules/role/constants/guard/guardConstants';
import { makeSelectFeatureEnabled } from '@/main/pages/PageAuth/selectors/authSelectors';

import { icons } from '../../../../../../assets';
import { EllipseText } from '../../../../../../components/common';
import { LayoutStyled } from '../../../../../../components/common/Block/Layout';
import { EWidgetSearchAccountsField, IWidgetSearchAccountsItem } from '../types/widgetSearchAccountsTypes';
import {
    WidgetSearchAccountsDisplayContainerStyled,
    WidgetSearchAccountsDisplayIconStyled,
    WidgetSearchAccountsDisplayItemStyled,
} from './styled/WidgetSearchAccountsStyled';

export interface IWidgetSearchAccountsDisplay {
    onClick: () => void;
    isOpened: boolean;
    selectedAccount: IWidgetSearchAccountsItem;
}

export const WidgetSearchAccountsDisplay = (props: IWidgetSearchAccountsDisplay) => {
    const isMainOperationsEnabled = useSelector(makeSelectFeatureEnabled(FeatureNameEnum.MAIN_OPERATIONS));
    return (
        <WidgetSearchAccountsDisplayContainerStyled
            onClick={props.onClick}
        >
            <LayoutStyled className="mr-2">
                {props.selectedAccount[EWidgetSearchAccountsField.number] ?? ''}
            </LayoutStyled>

            <EllipseText
                title={props.selectedAccount[EWidgetSearchAccountsField.region]}
                wrapper={WidgetSearchAccountsDisplayItemStyled}
                wrapperProps={{
                    isColorSecondary: true,
                    width: 'fit-content',
                    minWidth: 'fit-content',
                }}
            >
                {props.selectedAccount[EWidgetSearchAccountsField.region] ?? ''}
            </EllipseText>

            {
                isMainOperationsEnabled && 
                <EllipseText
                    title={props.selectedAccount[EWidgetSearchAccountsField.name] ?? ''}
                    wrapper={WidgetSearchAccountsDisplayItemStyled}
                    wrapperProps={{
                        isColorSecondary: true,
                        width: 'fit-content',
                    }}
                >
                    {props.selectedAccount[EWidgetSearchAccountsField.name] ?? ''}
                </EllipseText>
            }

            <WidgetSearchAccountsDisplayIconStyled src={props.isOpened ? icons.arrowUp : icons.arrowDown} />
        </WidgetSearchAccountsDisplayContainerStyled>
    )};
